import { Component, StrictMode, Suspense, lazy, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './stile.css'
import { Start } from './seiten/Start'
import { Uebung } from './seiten/Uebung'
import { TvAnsicht } from './seiten/TvAnsicht'
import { Koppeln } from './seiten/Koppeln'
import { TvCheck } from './seiten/TvCheck'
import { Einstellungen } from './seiten/Einstellungen'
import { Raum } from './seiten/Raum'
import { RaumBeitreten } from './seiten/RaumBeitreten'
import { Herde } from './seiten/Herde'

// Der Ausritt bringt Three.js mit (rund 600 kB). Nur laden, wer reitet:
// Der Fernseher und die Startseite bleiben schlank.
const Ritt = lazy(() => import('./seiten/Ritt').then((m) => ({ default: m.Ritt })))

/**
 * Fängt Fehler rund um den Ausritt ab, vor allem ein Teilstück, das offline
 * nicht nachgeladen werden kann. Ohne diese Grenze würde React den ganzen
 * Baum abräumen und Lina sähe eine weiße Seite.
 */
class RittGrenze extends Component<{ children: ReactNode }, { kaputt: boolean }> {
  state = { kaputt: false }

  static getDerivedStateFromError(): { kaputt: boolean } {
    return { kaputt: true }
  }

  componentDidCatch(fehler: unknown): void {
    console.error('[zahlenflug] Ausritt konnte nicht starten:', fehler)
  }

  render(): ReactNode {
    if (!this.state.kaputt) return this.props.children
    return (
      <div className="buehne">
        <div className="mitte">
          <p className="unterzeile">Der Ausritt lässt sich gerade nicht öffnen. Prüf das WLAN.</p>
          {/* Ein echter Seitenaufruf statt Link: React.lazy merkt sich den
              fehlgeschlagenen Import, erst ein Neuladen versucht es wieder. */}
          <a className="knopf knopf--leise" href="/herde">
            Zurück zur Herde
          </a>
        </div>
      </div>
    )
  }
}

const wurzel = document.getElementById('root')
if (!wurzel) throw new Error('Kein Wurzelelement gefunden.')

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/uebung" element={<Uebung />} />
        <Route path="/tv" element={<TvAnsicht />} />
        <Route path="/koppeln" element={<Koppeln />} />
        <Route path="/tv-check" element={<TvCheck />} />
        <Route path="/einstellungen" element={<Einstellungen />} />
        <Route path="/raum" element={<Raum />} />
        <Route path="/raum/beitreten" element={<RaumBeitreten />} />
        <Route path="/herde" element={<Herde />} />
        <Route
          path="/ritt"
          element={
            <RittGrenze>
              <Suspense fallback={<div className="buehne" />}>
                <Ritt />
              </Suspense>
            </RittGrenze>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
